import React, { useState } from 'react';
import { InputText } from 'components/inputText/inputText';
import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';
import { FormattedText, formatText } from 'core/i18n';
import validator from 'validator';
import { COUNTRY_CODE_ES, COUNTRY_CODE_DE } from 'commonsConstants/countryCodes';
import { InfoTooltip } from 'components/tooltip/tooltip';

export const Tin = ({ userProfile, userProfileForm, formActions, actions, submitButtonValidations, onFocus }) => {
    const [disabled, setDisabled] = useState(false);

    const requestValidateTin = tin => {
        setDisabled(true);
        formActions.change('userProfile.isValidatingTin', true);
        const country = getReferenceCodeByCountry().toUpperCase();
        actions.tinVerify(country, tin, ({ isValid }) => {
            formActions.setValidity('userProfile.tin', { valid: isValid });

            setDisabled(false);
            formActions.change('userProfile.isValidatingTin', false);
            submitButtonValidations?.(true);
        });
    };

    const buildTooltip = () => {
        if (__ORIGIN_COUNTRY__ === COUNTRY_CODE_DE) {
            return <InfoTooltip text={<FormattedText value={'tooltip-Tin'} />} />;
        }

        return null;
    };

    if (__ORIGIN_COUNTRY__ === COUNTRY_CODE_ES) return null;

    const isRequired = value => value && value.length;
    const isValid = value => validator.matches(value, /^[a-zA-Z\-0-9]*$/) && value.length <= 11;

    return (
        <InputText
            id="tin"
            disabled={disabled}
            profileModel="userProfile.tin"
            label={formatText('field-addTin')}
            tooltip={buildTooltip()}
            placeholder={formatText('field-placeholderTin')}
            onBlur={value => {
                value && requestValidateTin(value);

                return value;
            }}
            validations={{
                required: isRequired,
                valid: isValid,
            }}
            isNotValidated={() => submitButtonValidations?.(false)}
            isValidated={() => submitButtonValidations?.(true)}
            noFocusFromLabel
            userProfile={userProfile}
            userProfileForm={userProfileForm}
            formActions={formActions}
            isLoading={userProfile.isValidatingTin}
            onFocus={onFocus}
        />
    );
};
